"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilenameFromS3Key = void 0;
/** Get SeeSignage player compatible filename from S3 key.   */
const getFilenameFromS3Key = (key) => {
    const keyParts = key.split('/');
    if (keyParts[0] === 'common') {
        return `${key.split('/').join('_')}`;
    }
    const filename = keyParts.pop();
    if (filename) {
        return filename;
    }
    throw new Error(`getFilenameFromKey: undefined filename from ${key}`);
};
exports.getFilenameFromS3Key = getFilenameFromS3Key;
//# sourceMappingURL=s3.js.map